const LAST_WORKSPACE_ID = `lastWorkspaceId`;
const LAST_EXPERIMENTATION_GROUP = `lastExperimentationGroup`;
const LEFT_NAV_TOGGLE = `leftNavToggle`;
var LEFT_NAV_TOGGLE_STAGES = /* @__PURE__ */ ((LEFT_NAV_TOGGLE_STAGES2) => {
  LEFT_NAV_TOGGLE_STAGES2["expanded"] = "expanded";
  LEFT_NAV_TOGGLE_STAGES2["collapsed"] = "collapsed";
  return LEFT_NAV_TOGGLE_STAGES2;
})(LEFT_NAV_TOGGLE_STAGES || {});
export {
  LAST_EXPERIMENTATION_GROUP,
  LAST_WORKSPACE_ID,
  LEFT_NAV_TOGGLE,
  LEFT_NAV_TOGGLE_STAGES
};
//# sourceMappingURL=StudioLocalStorage.constants.js.map
